
import React from 'react';
import { Job } from "@/components/jobs/types";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface JobSourceUrlFieldProps {
  job: Pick<Job, 'source_url'>;
  isEditing: boolean;
  formDataUrl: string | undefined;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const JobSourceUrlField: React.FC<JobSourceUrlFieldProps> = ({ job, isEditing, formDataUrl, onInputChange }) => {
  return (
    <div className="md:col-span-2">
      <Label htmlFor="source_url" className="text-xs font-medium text-muted-foreground">Source URL</Label>
      {isEditing ? (
        <Input
          id="source_url"
          name="source_url"
          value={formDataUrl || ''}
          onChange={onInputChange}
          placeholder="e.g. https://company.com/careers/job123"
          className="text-sm"
        />
      ) : (
        job.source_url ? <a href={job.source_url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">{job.source_url}</a> : <p>N/A</p>
      )}
    </div>
  );
};
